import {useEffect, useState} from 'react';
import s from './logsItemList.module.css';
import { JsonView, allExpanded, defaultStyles } from 'react-json-view-lite';
import CollageItem from '../../CollageItem/CollageItem';
import { IUserRequest, ICollage } from '../types';
import {appAxiosInstance} from "../../../api";

export interface ICollageInformation {
    collage: string | null,
    styleId: number,
    styleName: string | null,
    totalCost: number,
    fashionGuid: string | null,
    commentStylist: string,
    adviceStylist: string
}

const LogsRecommendItemList = ({ log }: { log: IUserRequest }) => {
    const [showAllDetails, setShowAllDetails] = useState(false);
    const [showDetailsInfo, setShowDetailsInfo] = useState(false);
    const [showDetailsRecomendal, setShowDetailsRecomendal] = useState(false);
    const [showDetailsFiltered, setShowDetailsFiltered] = useState(false);
    const [showDetailsAnswerIsRecommended, setShowDetailsAnswerIsRecommended] = useState(false);
    const [showDetailsCollage, setShowDetailsCollage] = useState(false);
    const [collages, setCollages] = useState<ICollageInformation[]>([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCollage, setSelectedCollage] = useState<ICollageInformation | null>(null);

    const getCollages = async () => {
        try {
            const outerArray = JSON.parse(log.infoRequestAssistant);
            const innerObject = JSON.parse(outerArray[0]);
            const requestId = innerObject.requestId;

            const params = {
                requestId: requestId,
                withFitting: true
            }
            const response = await appAxiosInstance.get<ICollageInformation[]>('mobile/assistant/detailsFashionHistory',{params})
            const result = response.data;

            setCollages(result);
        } catch (error) {
            return { error: 'Недопустимый формат JSON' };
        }
    };

    const getObjectFromJson = (json: string) => {
        try {
            return JSON.parse(json);
        } catch (e) {
            return { error: 'Недопустимый формат JSON' };
        }
    }

    const handleCollageClick = (collage: ICollageInformation) => {
        setSelectedCollage(collage);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedCollage(null);
    };

    const CollageModal = () => {
        if (!selectedCollage) return null;

        return (
            <div className={s.modalOverlay} onClick={handleCloseModal}>
                <div className={s.modalContent} onClick={(e) => e.stopPropagation()}>
                    <button className={s.modalCloseButton} onClick={handleCloseModal}>×</button>

                    <div className={s.modalBody}>
                        <div className={s.modalImageContainer}>
                            <img
                                src={selectedCollage.collage || ''}
                                alt="Коллаж"
                                className={s.modalImage}
                            />
                        </div>

                        <div className={s.modalInfo}>
                            <h3 className={s.modalTitle}>{selectedCollage.styleName}</h3>

                            <div className={s.modalSection}>
                                <h4 className={s.modalSectionTitle}>Совет стилиста:</h4>
                                <p className={s.modalText}>{selectedCollage.adviceStylist}</p>
                            </div>

                            <div className={s.modalSection}>
                                <h4 className={s.modalSectionTitle}>Комментарий стилиста:</h4>
                                <p className={s.modalText}>{selectedCollage.commentStylist}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderCollages = () => {
        if (collages.length === 0) return null;

        return (
            <div className={s.collagesContainer}>
                <div className={s.collagesSlider}>
                    {collages.map((collage, index) => (
                        <div
                            key={index}
                            className={s.collage}
                            onClick={() => handleCollageClick(collage)}
                        >
                            <img
                                src={collage.collage || ''}
                                alt={`Коллаж ${index + 1}`}
                                className={s.collageImage}
                            />
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    useEffect(() => {
        getCollages();
    },[])

    return (
        <div className={s.tableLog}>
            <tr>
                <th onClick={() => setShowAllDetails(!showAllDetails)} className={showAllDetails ? `${s.heading} ${s.open}` : s.heading}>
                    Запрос от {log.requestDate} пользователя: {log.userName}
                </th>
            </tr>
            {showAllDetails && (
                <tbody>
                <tr className={s.logСharacteristics}>
                    <th onClick={() => setShowDetailsInfo(!showDetailsInfo)} className={showDetailsInfo ? `${s.showDetailsInfo} ${s.open}` : s.showDetailsInfo}>
                        Информация, которую передали ассистенту для подбора образов
                    </th>
                    {showDetailsInfo && (
                        <div className={s.logСharacteristicsValue}>
                            <tr>
                                <JsonView data={getObjectFromJson(log.infoRequestAssistant)} shouldExpandNode={allExpanded} style={defaultStyles} />
                            </tr>
                        </div>
                    )}
                </tr>
                <tr className={s.logСharacteristics}>
                    <th onClick={() => setShowDetailsAnswerIsRecommended(!showDetailsAnswerIsRecommended)} className={showDetailsAnswerIsRecommended ? `${s.showDetailsAnswerIsRecommended} ${s.open}` : s.showDetailsAnswerIsRecommended}>
                        Что рекомендалка отдала бэку
                    </th>
                    {showDetailsAnswerIsRecommended && (
                        <div className={s.logСharacteristicsValue}>
                            <tr>
                                <JsonView data={getObjectFromJson(log.infoInBackFromRecommendation)} shouldExpandNode={allExpanded} style={defaultStyles} />
                            </tr>
                        </div>
                    )}
                </tr>
                <tr className={s.logСharacteristics}>
                    <th onClick={() => setShowDetailsCollage(!showDetailsCollage)} className={showDetailsCollage ? `${s.showDetailsCollage} ${s.open}` : s.showDetailsCollage}>
                        Коллажи ({collages.length})
                    </th>
                    {showDetailsCollage && (
                        <div>
                            <tr>
                                {collages.length > 0 && renderCollages()}
                            </tr>
                        </div>
                    )}
                </tr>
                </tbody>
            )}

            <CollageModal />
        </div>
    );
};

export default LogsRecommendItemList;